import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ToolModelSelectorViewModel extends SelectorBaseViewModel<ToolModel> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<ToolModel[]> {
        let result = await ServerConnection.callServer('/Complex/ToolModelServices/ListAllToolModels', {})
        return await result.ToolModels.map(x => {
            let t = new ToolModel(this);
            t.id = x.Id;
            t.title = `${x.ToolTypeName} - ${x.Name} (${x.Code})`;
            return t;
        });
    }
}

export class ToolModel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}